import { Link, useLocation } from "react-router-dom";
import { Gift } from "lucide-react";
import { Button } from "@/components/ui/button";

const HIDDEN_PATHS = ["/free-pass", "/thank-you-3-day-guest-pass"];

export const FloatingFreePassButton = () => {
  const location = useLocation();
  if (HIDDEN_PATHS.includes(location.pathname)) {
    return null;
  }

  return (
    <Link
      to="/free-pass"
      className="inline-flex fixed bottom-24 right-4 md:bottom-6 md:right-6 z-40 shadow-lg rounded-full focus:outline-none focus:ring-2 focus:ring-brand-orange focus:ring-offset-2"
      data-testid="floating-free-pass-button"
      aria-label="1 Day Free Pass"
    >
      <Button
        size="lg"
        className="rounded-full h-14 px-5 bg-brand-orange hover:bg-brand-orange-hover text-white font-bold uppercase tracking-wider shadow-lg hover:shadow-xl transition-all"
      >
        <Gift className="w-5 h-5 mr-2" />
        1 Day Free Pass
      </Button>
    </Link>
  );
};

export default FloatingFreePassButton;
